<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item>USTED ESTA AQUI</b-breadcrumb-item>
      <b-breadcrumb-item>Administración</b-breadcrumb-item>
       <b-breadcrumb-item active>Usuarios</b-breadcrumb-item>
    </b-breadcrumb>
    <h2 class="page-title">Administrar - <span class="fw-semi-bold">Usuarios</span></h2>

    <vs-popup display="flex" title="Agregar Usuario" :active.sync="popupNewUserActive">
        <Widget customHeader>
          <div style="margin-left:20px">
                <b-row>
                    <b-col lg="6" sm="6" xs="12">
                      <div>
                          <label>Rol de usuario</label>
                          <Dropdown
                            :options="this.rolesJson"
                            :disabled="false"
                            v-on:selected="getSelectedRole"
                            name="ddnewrole"
                            :maxItem="10"
                            placeholder="Seleccionar rol"
                            ref="ddnewrole">
                          </Dropdown>
                      </div>
                    </b-col>
                      <b-col lg="6" sm="6" xs="6">
                          <label>Empresa</label>
                          <Dropdown
                            :options="this.myCompanyJson"
                            :disabled="false"
                            v-on:selected="getSelectedCompany"
                            name="ddnewcompany"
                            :maxItem="100"
                            placeholder="Seleccionar empresa"
                            ref="ddnewcompany">
                          </Dropdown>
                    </b-col>
                </b-row>
                
                <vs-divider/>

                <b-row>
                    <b-col lg="6" sm="6" xs="12">
                        <div class="vx-row">                          
                            <div class="vx-col sm:w-1/2 w-full mb-2">
                                <label>Usuario</label>
                                <input class="form-control no-border" 
                                v-model="this.new_user_name" ref="newNameUser" />
                            </div>
                        </div>                      
                    </b-col>
                    <b-col lg="6" sm="6" xs="12">
                        <div class="vx-row">                           
                            <div class="vx-col sm:w-1/2 w-full mb-2">
                                <label>Correo</label>
                                <input type="email" class="form-control no-border"
                                v-model="this.new_user_mail" ref="newMailUser"/>
                            </div>                        
                        </div>
                    </b-col>
                </b-row>

                 <b-row>
                    <b-col lg="6" sm="6" xs="12">
                      <div class="vx-row">                                                   
                          <div class="vx-col sm:w-1/2 w-full mb-2">
                              <label>Contraseña (max: 16)</label>
                              <input class="form-control no-border"
                              v-model="this.new_user_pass" ref="newPassUser"/>
                          </div>
                      </div>
                    </b-col>
                </b-row>
              
              <vs-divider/>
              <div class="vx-row">
                  <div style="text-align:right" class="vx-col w-full">
                      <vs-button class="mr-3 mb-2" @click="createNewUserRequest">Guardar</vs-button>
                      <vs-button color="warning" type="border" class="mb-2" @click="closePopPupNewUser">Cancelar</vs-button>
                  </div>
              </div>
          </div>
        </Widget>
    </vs-popup>

    <vs-popup display="flex" title="Editar Usuario" :active.sync="popupEditActive">
        <Widget customHeader>
                <div style="margin-left:20px">
                      <b-row>
                          <b-input-group>
                              <b-dropdown text="Rol" variant="info" ref="ddRole">
                                <b-dropdown-item v-for="option in options"
                                                  :key="option.id_role" 
                                                  :value="option.name"
                                                  @click="getRole(option.id_role,option.name)"
                                                  >
                                              {{option.name}}
                                </b-dropdown-item> 
                              </b-dropdown>

                              <b-form-input v-model="this.edit_role_name_user"></b-form-input>
                            </b-input-group>

                      </b-row>
                      <b-row>
                          <b-col lg="6" sm="6" xs="12">
                              <div class="vx-row">
                                  <div class="vx-col sm:w-1/2 w-full mb-2">
                                      <label>ID Usuario</label>
                                      <input class="form-control no-border" 
                                      disabled v-model="this.edit_id_user" />
                                  </div>
                                  <div class="vx-col sm:w-1/2 w-full mb-2">
                                      <label>Usuario</label>
                                      <input class="form-control no-border" 
                                      v-model="this.edit_name_user" ref="nameUser" />
                                  </div>
                              </div>
                              <div class="vx-row">
                                  <div class="vx-col sm:w-1/2 w-full mb-2">
                                      <label>Empresa</label>
                                      <input class="form-control no-border" 
                                      v-model="this.edit_name_company" ref="nameCompany" />
                                  </div>
                              </div>
                          </b-col>
                          <b-col lg="6" sm="6" xs="12">
                              <div class="vx-row">
                                  <div class="vx-col sm:w-1/2 w-full mb-2">
                                      <label>Región</label>
                                      <input class="form-control no-border" 
                                      v-model="this.edit_name_region" ref="nameRegion" />
                                  </div>
                                  <div class="vx-col sm:w-1/2 w-full mb-2">
                                      <label>Agencia</label>
                                      <input class="form-control no-border" 
                                      v-model="this.edit_name_location" ref="nameLocation"/>
                                  </div>
                                  <div class="vx-col sm:w-1/2 w-full mb-2">
                                      <label>Correo</label>
                                      <input type="email" class="form-control no-border"
                                      v-model="this.edit_mail_user" ref="mailUser"/>
                                  </div>
                                  <label>Activo:     </label>
                                  <input style="margin-left:10px;margin-top:5px" type="checkbox" 
                                  :checked="this.edit_status_user_check" ref="statusUser"/>
                              </div>
                          </b-col>
                      </b-row>
                    
                    <vs-divider/>
                    <div class="vx-row">
                        <div style="text-align:right" class="vx-col w-full">
                            <vs-button class="mr-3 mb-2" @click="editUser">Guardar</vs-button>
                            <vs-button color="warning" type="border" class="mb-2" @click="closePopPupEditUser">Cancelar</vs-button>
                        </div>
                    </div>
                </div>
        </Widget>
    </vs-popup>

    <vs-popup title="Eliminar Usuario" :active.sync="popupDeleteActive">
        <Widget customHeader>
                <div style="margin-left:20px" >
                    <b-row>
                        <b-col lg="12" sm="6" xs="12">
                            <div class="vx-row">
                                <h4 class="page-title">Está seguro que desea darle de baja al usuario 
                                <span class="fw-semi-bold">{{this.edit_name_user}} ?</span></h4>
                            </div>
                        </b-col>
                    </b-row>
                    <vs-divider/>
                    <div class="vx-row">
                        <div style="text-align:right" class="vx-col w-full">
                            <vs-button class="mr-3 mb-2" @click="deleteUser">Eliminar</vs-button>
                            <vs-button color="warning" type="border" class="mb-2" 
                            @click="closePopPupDeleteUser">Cancelar</vs-button>
                        </div>
                    </div>
                </div>
        </Widget>
    </vs-popup>

    <p>
      <b-button
            variant="success" id="show-success-message" @click="openPopPupNewUser"
          >+ Agregar Nuevo Usuario +
      </b-button>
    </p>

     <table class="table table-striped">
           <thead>
             <tr>
               <th>ID</th>
               <th>USUARIO</th>
               <th>EMPRESA</th>          
               <th>EMAIL</th>
               <th>ESTADO</th>
               <th>EDITAR</th>
               <th>BORRAR</th>
             </tr>
           </thead>
           <tbody>
             <tr v-for="row in myJson" :key="row.id_user">
               <td>{{row.id_user}}</td>
               <td>{{row.name_user}}</td>
               <td>{{row.name_company}}</td>            
               <td>{{row.mail_user}}</td>
               <td>
                   <b-badge v-if="row.status_user == 1" variant="success">Activo</b-badge>
                   <b-badge v-else variant="gray">Inactivo</b-badge>
               </td>
               <td><b-button variant="success" class="p-1 px-3 btn-xs" 
                    @click="openPopPupEditUser(row.id_user+'|'+row.name_user+'|'+row.name_company+'|'+row.name_region+'|'+row.name_location+'|'+row.mail_user+'|'+row.status_user)" >Editar</b-button></td>
               <td><b-button variant="danger" class="p-1 px-3 btn-xs" 
                    @click="openPopPupDeleteUser(row.id_user+'|'+row.name_user+'|'+row.name_company+'|'+row.name_region+'|'+row.name_location+'|'+row.mail_user+'|'+row.status_user)">Borrar</b-button></td>
             </tr>
           </tbody>
         </table>
  </div>
</template>

<script>

import dropdown from 'vue-dropdowns';

import Dropdown from 'vue-simple-search-dropdown';

/* eslint-disable */
import 'imports-loader?jQuery=jquery,this=>window!flot';
import 'imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.pie';
/* eslint-enable */
import Widget from '@/components/Widget/Widget';

import Media from '@dongido/vue-viaudio';

import axios from "axios";

import 'imports-loader?$=jquery,this=>window!messenger/build/js/messenger'; // eslint-disable-line

const currentDate = new Date()

const { Messenger } = window;

function initializationMessengerCode() {
  (function () {
    let $,
      FlatMessage,
      spinner_template,
      __hasProp = {}.hasOwnProperty,
      __extends = function (child, parent) {
        for (const key in parent) {
          if (__hasProp.call(parent, key)) child[key] = parent[key];
        }
        function ctor() {
          this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
      };

    $ = jQuery;

    spinner_template = '<div class="messenger-spinner">\n    <span class="messenger-spinner-side messenger-spinner-side-left">\n        <span class="messenger-spinner-fill"></span>\n    </span>\n    <span class="messenger-spinner-side messenger-spinner-side-right">\n        <span class="messenger-spinner-fill"></span>\n    </span>\n</div>';

    FlatMessage = (function (_super) {
      __extends(FlatMessage, _super);

      function FlatMessage() {
        return FlatMessage.__super__.constructor.apply(this, arguments);
      }

      FlatMessage.prototype.template = function (opts) {
        let $message;
        $message = FlatMessage.__super__.template.apply(this, arguments);
        $message.append($(spinner_template));
        return $message;
      };

      return FlatMessage;
    }(Messenger.Message));

    Messenger.themes.air = {
      Message: FlatMessage,
    };
  }).call(window);
};

export default {          

  name: 'abcUsuarios',
  components: { Widget,Media,Dropdown },
  data() {
    return {
  
      ddTestSelectedOption: "Value1",
  
      myJson: null,
      rolesJson: null,
      myCompanyJson: null,
      popupEditActive: false,
      popupDeleteActive: false,
      popupNewUserActive: false,
      ddRoleValue: "valor",

      //TO NEW USER
      new_user_role: 0,
      new_user_company: 0,
      new_user_name: "",
      new_user_pass: "",
      new_user_mail: "",

      //TO EDIT USER
      edit_id_user: 0,
      edit_name_user: "",
      edit_name_company: "",
      edit_name_region: "",
      edit_name_location: "",
      edit_mail_user: "",
      edit_status_user: 0,
      edit_status_user_check: false,
      edit_id_role_user: "",
      edit_role_name_user: "",

      edit_id_new_role_user: "",
      edit_role_new_name_user: "",

      edit_id_role: "",

      locationClasses: 'messenger-fixed messenger-on-top messenger-on-center'
    };
  },
  methods: {

    getSelectedRole(){
      this.new_user_role = this.$refs.ddnewrole.selected.id;
      //console.log(this.new_user_role);
    },

    getSelectedCompany(){
      this.new_user_company = this.$refs.ddnewcompany.selected.id;
      //console.log(this.new_user_role);
    },

   getRolesRequest(){
        axios({ method: "POST", "url": "http://3.232.184.255:8080/corpolex-get_roles" }).then(result => {
                this.rolesJson = result.data;
                console.log(this.rolesJson);    
                this.getCompaniesList();           
        }, error => {                
            console.log(result);
            console.log(error);
        });
    },
    
    getCompaniesList(){
        axios({ method: "POST", "url": "http://3.232.184.255:8080/corpolex-get_companies_list"  }).then(res => {
                this.myCompanyJson = res.data;
                console.log(this.myCompanyJson);
        }, error => {
            console.log('res');
            console.log(error);
        });
    },

    getUsers(){
        axios({ method: "POST", "url": "http://3.232.184.255:8080/corpolex-get_users" }).then(result => {
                this.myJson = result.data;
                console.log(this.myJson);               
        }, error => {                
            console.log(result);
            console.log(error);
        });
    },

    createNewUserRequest(){
      if(this.$refs.newNameUser.value.length < 3){
        alert("Nombre de usuario debe tener al menos 3 caracteres")
      }
      else if(this.$refs.newPassUser.value.length < 5){
        alert("Contraseña debe tener al menos 5 caracteres");
      }
      else{
         axios.post('http://3.232.184.255:8080/new_corpolex_user', "{no-data}", {
         headers: {
         'Content-type': 'application/x-www-form-urlencoded',
         'i_r': this.new_user_role,
         'i_c': this.new_user_company,
         'n_u': this.$refs.newNameUser.value,
         'p_u': this.$refs.newPassUser.value,
         'm_u': this.$refs.newMailUser.value,
       }
      }).then(r => 
        {
          this.myJson = r.data;
          console.log(this.myJson)
          
          if (this.myJson[0].state_code == 'INSERTED') {
            this.popupNewUserActive = false;
            this.addDoneNotification()
            this.getUsers();
          }
          else{
            this.addErrorNotification();
            this.getUsers();
          }
        }),
        error => {
          console.log(r);
          console.log(error);
        };
      }

      
    },
    editUser(){
         axios.post('http://3.232.184.255:8080/edit_user', "{no-data}", 
      {
          headers: {
          'Content-type': 'application/x-www-form-urlencoded',
          'i_u': this.edit_id_user,
          'n_u': this.$refs.nameUser.value,
          'n_c': this.$refs.nameCompany.value,
          'n_r': this.$refs.nameRegion.value,
          'n_l': this.$refs.nameLocation.value,
          'm_u': this.$refs.mailUser.value,
          's_u': this.$refs.statusUser.value
        }
      }).then(r => 
        {
            this.myJson = r.data;
            console.log(this.myJson)
            
            if (this.myJson[0].state_code == 'DONE') {
              this.popupEditActive = false;
              this.addDoneNotification()
              this.getUsers();
            }
            else{
              this.addErrorNotification();
            }
        }),
        error => {
                console.log(r);
                console.log(error);
            }; 
    },
    deleteUser(){
         axios.post('http://3.232.184.255:8080/delete_user', "{no-data}", 
      {
          headers: {
          'Content-type': 'application/x-www-form-urlencoded',
          'i_c': this.edit_id_user
        }
      }).then(r => 
        {
            this.myJson = r.data;
            console.log(this.myJson)
            
            if (this.myJson[0].state_code == 'DONE') {
              this.popupDeleteActive = false;
              this.addDoneDeleteNotification()
              this.getUsers();
            }
            else{
              this.addErrorNotification();
            }
        }),
        error => {
              console.log(r);
              console.log(error);
            }; 
    },

    openPopPupEditUser(text){
        
        console.log('TEXT_TO_SPLIT',text);

        var split = text.split("|");
        
        this.edit_id_user = split[0];
        this.edit_name_user = split[1];
        this.edit_name_company = split[2];
        this.edit_name_region = split[3];
        this.edit_name_location = split[4];
        this.edit_mail_user = split[5];
        this.edit_status_user = split[6];
        
        if(this.edit_status_user == "1"){
            this.edit_status_user_check = true
        }
        else{this.edit_status_user_check = false}

        this.popupEditActive = true;
    },
    openPopPupNewUser(text){
        this.popupNewUserActive = true;
        this.getRolesRequest();
        
    },
    closePopPupNewUser(){
        this.popupNewUserActive = false;
    },
    openPopPupDeleteUser(text){
        
        var split = text.split("|");
        
        this.edit_id_company = split[0];
        this.edit_name_company = split[1];
        this.edit_address_company = split[2];
        this.edit_telephone1_company = split[3];
        this.edit_telephone2_company = split[4];
        this.edit_email_company = split[5];
        this.edit_status_company = split[6];
        
        if(this.edit_status_company == "1"){
            this.edit_status_company_check = true
        }
        else{this.edit_status_company_check = false}

        this.popupDeleteActive = true;
    },
    closePopPupEditUser(){
        this.popupEditActive = false;
    },
    closePopPupDeleteUser(){
        this.popupDeleteActive = false;
    },
    printsAll(){
        console.log(this.$refs.nameCompany.value);
    },
    //NOTIFICATIONS
    addGenericNotification(msg) {
        Messenger().post({
          message: msg,
          type: 'error',
          showCloseButton: true
        });
    },
    addErrorNotification() {
        Messenger().post({
          message: 'Ha ocurrido un error al guardar los cambios para el usuario ' + this.edit_name_user,
          type: 'error',
          showCloseButton: true
        });
    },
    addDoneNotification() {
        Messenger().post({
          message: 'Se han guardado los cambios para el usuario ' + this.new_user_name + ' con éxito.',
          type: 'success',
          showCloseButton: true
        });
    },
    addDoneDeleteNotification() {
        Messenger().post({
          message: 'Se ha dado de baja al usuario ' + this.edit_name_user + ' con éxito.',
          type: 'success',
          showCloseButton: true
        });
    },
  },
  mounted() {
    this.getUsers();
    
  },
  created(){
    
    initializationMessengerCode();

    Messenger.options = {
      extraClasses: this.locationClasses,
      theme: 'air',
    };
  }
};
</script>


